import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import SentimentSatisfiedIcon from "@mui/icons-material/SentimentSatisfied";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAltOutlined";
import SentimentVerySatisfiedIcon from "@mui/icons-material/SentimentVerySatisfied";
import { Box } from "@mui/system";
import { Rating } from "@mui/material";
export default function StyledRatingComponent(params) {
  const {
    setRating = () => {},
    questionId = null,
    rating,
    valueDefault = null,
  } = params;

  const StyledRating = styled(Rating)(({ theme }) => ({
    "& .MuiRating-iconEmpty .MuiSvgIcon-root": {
      color: theme.palette.action.disabled,
    },
  }));

  const customIcons = {
    1: {
      icon: <SentimentVeryDissatisfiedIcon color="error" />,
      label: "Very Dissatisfied",
    },
    2: {
      icon: <SentimentDissatisfiedIcon color="error" />,
      label: "Dissatisfied",
    },
    3: {
      icon: <SentimentSatisfiedIcon color="warning" />,
      label: "Neutral",
    },
    4: {
      icon: <SentimentSatisfiedAltIcon color="success" />,
      label: "Satisfied",
    },
    5: {
      icon: <SentimentVerySatisfiedIcon color="success" />,
      label: "Very Satisfied",
    },
  };
  function IconContainer(props) {
    const { value, ...other } = props;
    return (
      <Box sx={{ margin: "0 7px" }} {...other}>
        {customIcons[value].icon}
      </Box>
    );
  }
  const valorSelecionado =
    rating?.find((r) => r.questionId === questionId)?.answer ?? null;
  return (
    <StyledRating
      name="highlight-selected-only"
      IconContainerComponent={IconContainer}
      value={valueDefault || valorSelecionado}
      onChange={(event, newValue) => {
        if (newValue !== null) {
          setRating((prev) => {
            const jaExiste = prev?.find((r) => r?.questionId === questionId);

            if (jaExiste) {
              return prev.map((r) =>
                r.questionId === questionId
                  ? { questionId, answer: newValue }
                  : r
              );
            }

            return [...prev, { questionId, answer: newValue }];
          });
        }
      }}
      getLabelText={(value) => customIcons[value].label}
      highlightSelectedOnly
      readOnly={valueDefault}
    />
  );
}
